import { Base } from './base.model';
import { alias, deserialize, serializable } from 'serializr';
import { PageObject } from './page-object.model';

export class RequirementType extends Base implements PageObject {
  @serializable
  public name: string;
  @serializable(alias('project_id'))
  public projectId: number;
  @serializable
  public displayName: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(RequirementType, input));
  }
}
